import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=dc9434a6"
import script from "./UserPage.vue?vue&type=script&lang=ts"
export * from "./UserPage.vue?vue&type=script&lang=ts"
import style0 from "./UserPage.vue?vue&type=style&index=0&id=dc9434a6&prod&lang=css"
import style1 from "./UserPage.vue?vue&type=style&index=1&id=dc9434a6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports